import { ScrollToTop } from "@/shared/lib/ScrollToTop";
import { BaseButton } from "@/shared/ui/BaseButton";
import { BaseBreadCrumb } from "@/shared/ui/base-bread-crumb";
import { Box, Container, Stack, Typography } from "@mui/material";
import { Link } from "@tanstack/react-router";
import type { MasterDataVehicleCreatePageProps } from "../../model";
import { MasterDataVehicleInfo } from "./master-data-vehicle-info";

export const MasterDataVehicleDetailPreview = ({
  offices,
  previewValues,
  onSubmitClick,
  onBackToInProgressClick,
}: MasterDataVehicleCreatePageProps) => {
  const links = [
    { href: "/master-data/vehicles", label: "車両管理" },
    { label: "車両新規登録" },
  ];

  if (!previewValues) {
    return null;
  }
  return (
    <Box>
      <ScrollToTop />
      <BaseBreadCrumb links={links} sx={{ mb: 3, px: 4 }} />
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          px: 4,
        }}
      >
        <Typography
          variant="h5"
          sx={{
            fontWeight: 700,
          }}
        >
          車両新規登録
        </Typography>
      </Box>
      <Box
        display="flex"
        mt={4}
        mb={2}
        px={{ xs: 2, sm: 0 }}
        bgcolor="grey.50"
        minHeight="600px"
        flexDirection={"column"}
        flexGrow={1}
      >
        <Container
          maxWidth="md"
          sx={{
            bgcolor: "white",
            mt: 4,
            mb: { xs: 4, sm: 7 },
            p: { xs: 2, sm: 4 },
            border: "1px solid",
            borderColor: "grey.200",
            borderRadius: "16px",
          }}
        >
          <MasterDataVehicleInfo
            offices={offices}
            previewValues={previewValues}
          />
        </Container>
      </Box>
      <Stack spacing={1} mb={2}>
        <Stack direction="row" spacing={1} justifyContent="center">
          <BaseButton
            LinkComponent={Link}
            variant="outlined"
            color="primary"
            sx={{
              width: { xs: "96px", sm: "96px" },
              fontSize: "14px",
              fontWeight: 700,
            }}
            onClick={onBackToInProgressClick}
          >
            修正する
          </BaseButton>
          <BaseButton
            variant="contained"
            color="primary"
            sx={{
              width: { xs: "150px", sm: "240px" },
              fontSize: "14px",
              fontWeight: 700,
            }}
            onClick={onSubmitClick}
          >
            登録する
          </BaseButton>
        </Stack>
      </Stack>
    </Box>
  );
};
